import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { Subscription } from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-subject-details-widget',
  templateUrl: './subject-details-widget.component.html',
  styleUrls: ['./subject-details-widget.component.css']
})
export class SubjectDetailsWidgetComponent implements OnChanges {

   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '';
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full
  subject_id: any;
  subjects: any;
  job_id: any;
  file_number: any;
  subject_contact_numbers: any;
  subject_contact_emails: any;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe
  ) { }

    // check for changes. to load data.
    ngOnChanges(changes) {
      if (changes.item_id) {
        // deal with asynchronous Observable result
        this.subject_id = changes.item_id.currentValue;
        this.getJobSubject(this.subject_id);
        this.getSubjectContactNumbers(this.subject_id);
        this.getSubjectContactEmails(this.subject_id);
      }
    }


// functions

getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
     data => { this.subjects = data;
      const res = data[0];
 
      //     this.getSubjectNotes(res.subject_id);
      // load subject history
 //     this.getSubjectProgress(res.job_id, res.file_number);

// get job type in relation to subject
/*
this.getJobType(res.job_type_id);
this.getJobTypeLocation(res.job_type_location_id);
this.getJobTypeCourt(res.job_type_court_id);
this.getJobTypeDocument(res.job_type_document_type_id);
this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
*/
this.job_id = res.job_id;
this.file_number = res.file_number;
// this.getSubjectNotesProgressionTable(res.job_id, res.file_number );

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getSubjectContactEmails(subject_id) {
  this._demoService.getSubjectContactEmails(subject_id).subscribe(
     data => { this.subject_contact_emails = data; },
     err => console.error(err),
      () => {
        console.log('done loading SR');
                    }
        );
 }



getSubjectContactNumbers(subject_id) {
  this._demoService.getSubjectContactNumbers(subject_id).subscribe(
     data => { this.subject_contact_numbers = data; },
     err => console.error(err),
      () => {
        console.log('done loading SCN');
                    }
        );
 }




}
